module.exports = __webpack_public_path__ + "static/media/right-arrow-black.7fca7109.svg";